import {
	Component,
	OnChanges,
	Input,
	Output,
	EventEmitter,
} from '@angular/core'
import ListItem, { DescriptionInput } from '@ui/ListItem'
import {
	ListItemAction,
	ListItemActionComponent,
} from '@ui/Components/List/ListItemAction.Component'
import { SelectionModel } from '@angular/cdk/collections'
import { CardComponent } from '@ui/Components/Card/Card.Component'
import { CardTitleComponent } from '@ui/Components/Card/CardTitle.Component'
import { CardContentComponent } from '@ui/Components/Card/CardContent.Component'
import { CardActionsComponent } from '@ui/Components/Card/CardActions.Component'
import {
	CheckboxValueChange,
	TableCellCheckboxComponent,
} from '@ui/Components/Table/Checkbox/TableCellCheckbox.Component'
import { NgStyle } from '@angular/common'

@Component({
	selector: 'list-item',
	templateUrl: './ListItem.Component.html',
	styleUrls: ['./ListItem.Component.css'],
	imports: [
		CardComponent,
		CardTitleComponent,
		CardContentComponent,
		ListItemActionComponent,
		CardActionsComponent,
		TableCellCheckboxComponent,
		NgStyle,
	],
})
export class ListItemComponent implements OnChanges {
	@Input() public item: ListItem

	@Input() public actions: ListItemAction[]

	@Input() public deleteSelection: SelectionModel<ListItem>

	@Input() private readonly descriptionParams: DescriptionInput = {}

	@Output() private readonly deleteSelectionChecked =
		new EventEmitter<CheckboxValueChange>()

	public title: string

	public image: string

	public description: string | undefined

	public ngOnChanges(): void {
		this.title = this.item.getTitle()

		this.image = this.item.getImage()

		let description = this.item.getDescription(this.descriptionParams)

		if (description) {
			description = description.replace(/(?:\r\n|\r|\n)/g, '<br />')
			this.description = description
		} else {
			this.description = ''
		}
	}

	public actionTracker = (index: number) => index

	public handleToggle = (event: CheckboxValueChange) => {
		this.deleteSelectionChecked.emit(event)
	}
}
